import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2 bg-gray-100 rounded-full p-1" data-testid="language-selector">
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
          language === 'en' 
            ? 'bg-white text-emerald-600 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        data-testid="lang-en"
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('hi')}
        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
          language === 'hi' 
            ? 'bg-white text-emerald-600 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        data-testid="lang-hi"
      >
        हिंदी
      </button>
    </div>
  );
};

export const LanguageSelectorMini = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm font-medium transition-all"
      data-testid="language-toggle"
    >
      <Globe size={16} className="text-emerald-600" />
      <span>{language === 'en' ? 'हिंदी' : 'EN'}</span>
    </button>
  );
};
